import { Typography } from "@mui/material";
import CenteredCard from "../layout/CenteredCard";

export default function Contract() {
  return (
    <CenteredCard maxWidth="80%">
      
    </CenteredCard>
  );
};